import { gql } from "@urql/core";

export const UserFootprintsFragment = gql`
    fragment UserFootprintsFragment on GrowthUnifiedProfileResult {
        userFootprints {
            products
            hasAtlassianAccount
        }
    }
`;
